import { Box, List, ListItemButton, ListItemIcon, ListItemText, Collapse, Typography } from '@mui/material'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { TransitionGroup } from 'react-transition-group'
import { TaskItem } from './task-item'

/**
 * Collapsible task group component
 *
 * Handles both:
 * - Ungrouped tasks (no label, render tasks directly)
 * - Grouped tasks (with label, collapsible)
 */
export const TaskGroup = ({ group, isExpanded, onToggle, onUpdateTask }) => {

  if (group.tasks.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="text.secondary">No tasks in filter range</Typography>
      </Box>
    )
  }

  // If no label (ungrouped), render tasks directly without collapse
  if (!group.label) {
    return (
      <List disablePadding>
        <TransitionGroup>
          {group.tasks.map(task => (
            <Collapse key={task.id}>
              <TaskItem task={task} onUpdateTask={onUpdateTask} />
            </Collapse>
          ))}
        </TransitionGroup>
      </List>
    )
  }

  // Grouped: render with collapse
  return (
    <Box sx={{ mb: 1 }}>
      <ListItemButton
        onClick={() => onToggle(group.id)}
        sx={{
          bgcolor: 'action.hover',
          gap: 1,
          py: 0,
          '&:hover': {
            bgcolor: 'primary.400',
            color: 'primary.contrastText',
            '& .MuiSvgIcon-root': {
              color: 'primary.contrastText'
            },
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 0 }}>
          {isExpanded ? <ExpandLess /> : <ExpandMore />}
        </ListItemIcon>
        <ListItemText primary={`${group.label} (${group.tasks.length})`}/>
      </ListItemButton>

      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <List disablePadding>
          <TransitionGroup>
            {group.tasks.map(task => (
              <Collapse key={task.id}>
                <TaskItem task={task} onUpdateTask={onUpdateTask} />
              </Collapse>
            ))}
          </TransitionGroup>
        </List>
      </Collapse>
    </Box>
  )
}
